import axios from "axios";
import { FLIPPER_API_URL } from "../config";

export const flipperHttpClient = axios.create({
  baseURL: `https://${FLIPPER_API_URL}`,
  timeout: 4000,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});
